import { render, staticRenderFns } from "./SearchFilterTag.vue?vue&type=template&id=587950a0"
import script from "./SearchFilterTag.vue?vue&type=script&lang=ts"
export * from "./SearchFilterTag.vue?vue&type=script&lang=ts"
import style0 from "./SearchFilterTag.vue?vue&type=style&index=0&id=587950a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports